module.exports = __webpack_public_path__ + "img/rep-charles.524d3793.png";